module.exports = __webpack_public_path__ + "static/media/pricing2.0d6b40d2.png";